import React from "react";
import { Building2, UserRound } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import Services from "./Services";
import Jobs from "./Jobs";

const AudienceSection = ({ mode, setMode, onInquiry, onApply }) => {
  const { t } = useLanguage();

  return (
    <section id="audience" className="relative py-24 lg:py-32 scroll-mt-20">
      <div className="container-px mx-auto max-w-7xl">
        <div className="reveal text-center">
          <h2 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
            {t.audience.heading}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/60">{t.audience.subheading}</p>

          {/* Segmented toggle */}
          <div className="mt-9 inline-flex items-center rounded-full border border-white/15 bg-white/5 p-1.5 backdrop-blur-md">
            <button
              onClick={() => setMode("company")}
              className={`flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold transition-all duration-300 ${
                mode === "company" ? "bg-white text-black shadow-lg" : "text-white/65 hover:text-white"
              }`}
            >
              <Building2 className="h-4 w-4" />
              {t.audience.companyTab}
            </button>
            <button
              onClick={() => setMode("worker")}
              className={`flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold transition-all duration-300 ${
                mode === "worker" ? "bg-white text-black shadow-lg" : "text-white/65 hover:text-white"
              }`}
            >
              <UserRound className="h-4 w-4" />
              {t.audience.workerTab}
            </button>
          </div>
        </div>

        <div className="mt-16">
          {mode === "company" ? <Services onInquiry={onInquiry} /> : <Jobs onApply={onApply} />}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
